<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="3" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          Edit Level
        </v-card-title>
        <v-card-text>
          <v-row align="center">
            <v-col sm="3">
              <v-autocomplete
                outlined
                v-model="form.type"
                :items="typeItems"
                label="Level Type *"
                prepend-inner-icon="mdi-account-tie-outline"
                clearable
                :error-messages="errors.type"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.min_levels"
                outlined
                label="Minimum Level"
                type="number"
                prepend-inner-icon="mdi-chevron-up"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.max_levels"
                outlined
                label="Maximum Level"
                type="number"
                prepend-inner-icon="mdi-chevron-double-up"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.coins"
                outlined
                label="Coins"
                type="number"
                prepend-inner-icon="mdi-bitcoin"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update Level
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "LevelIdPage",
  data() {
    return {
      form: {
        is_active: false,
      },
      typeItems: [
        { id: 1, text: "Charm", value: 1 },
        { id: 2, text: "Wealth", value: 0 },
      ],
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.levelId;
      axios
        .get(`/levels/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          this.old_json = response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        console.log(this.form);
        await axios.patch(`/levels/${this.$route.params.levelId}`, this.form);
        await this.saveUserTimestamp(this.old_json, this.form);
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
      }
    },
    async saveUserTimestamp() {
      try {
        let form = {
          from_path: `/level/${this.form.id}`,
          from_name: "LevelIdPage",
          user_id: this.user.id,
          old_json: JSON.stringify(this.old_json),
          new_json: JSON.stringify(this.form),
        };
        await axios.post(`/user_timestamps`, form);
        this.$router.push("/levels");
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
